@if (hasRange) {
  <mat-form-field
    [subscriptSizing]="subscriptSizing()"
    [class.filled]="!!startControl.value?.toString().length || !!endControl.value?.toString().length"
    appearance="outline"
    class="rp-date-picker"
    #formField
  >
    <mat-label>{{ label() }}</mat-label>

    <mat-date-range-input [max]="maxDate()" [min]="minDate()" [rangePicker]="picker" [disabled]="isDisabled()">
      <input
        matStartDate
        readonly
        [formControl]="startControl"
        (focus)="picker.open()"
        (click)="picker.open()"
        [placeholder]="placeholderStart()"
      />

      <input
        matEndDate
        readonly
        [formControl]="endControl"
        (focus)="picker.open()"
        (click)="picker.open()"
        [placeholder]="placeholderEnd()"
      />
    </mat-date-range-input>

    @if (hint()) {
      <mat-hint>{{ hint() }}</mat-hint>
    }

    <div class="rp-date-picker-suffix" matSuffix>
      @if (clearable() && (startControl.value || endControl.value)) {
        <rp-icon class="clear-icon" [iconName]="icons.ResetFilter" size="s" (click)="onClear()" />
      }

      <mat-datepicker-toggle #datePickerToggle [for]="picker" [disableRipple]="true">
        <rp-icon class="calendar-icon" [iconName]="icons.Calendar" size="s" matDatepickerToggleIcon />
      </mat-datepicker-toggle>
    </div>

    <mat-date-range-picker #picker [calendarHeaderComponent]="datePickerHeader" (closed)="onClose()">
      <mat-date-range-picker-actions>
        <rp-date-picker-actions (selectPreset)="onSelectPreset($event)" />
      </mat-date-range-picker-actions>
    </mat-date-range-picker>

    @if (showErrorMessage()) {
      @let startControlErrors = startControl.errors | objectKeysToArray;
      @let endControlErrors = endControl.errors | objectKeysToArray;

      @if ((startControlErrors | includes: patternValidations) || (endControlErrors | includes: patternValidations)) {
        <mat-error>{{ 'validations.pattern' | translate }}</mat-error>
      } @else if (startControl.hasError('required') || endControl.hasError('required')) {
        <mat-error>{{ 'validations.required' | translate }}</mat-error>
      }
    }
  </mat-form-field>
} @else {
  <mat-form-field
    [subscriptSizing]="subscriptSizing()"
    [class.filled]="!!ngControl.control.value?.toString().length"
    appearance="outline"
    class="rp-date-picker"
  >
    <mat-label>{{ label() }}</mat-label>
    <input
      [max]="maxDate()"
      [min]="minDate()"
      matInput
      [matDatepicker]="picker"
      [formControl]="ngControl.control"
      [errorStateMatcher]="matcher()"
      [placeholder]="placeholder()"
      (focus)="picker.open()"
      (click)="picker.open()"
      readonly
      (dateChange)="dateChange.emit($event)"
    />
    @if (hint()) {
      <mat-hint>{{ hint() }}</mat-hint>
    }

    <div class="rp-date-picker-suffix" matSuffix>
      @if (clearable() && (startControl.value || endControl.value)) {
        <rp-icon class="calendar-icon" [iconName]="icons.ResetFilter" size="s" (click)="onClear()" />
      }

      <mat-datepicker-toggle [for]="picker" [disableRipple]="true">
        <rp-icon class="calendar-icon" [iconName]="icons.Calendar" size="s" matDatepickerToggleIcon />
      </mat-datepicker-toggle>
    </div>

    <mat-datepicker #picker />

    @if (ngControl.control.hasError('required') && ngControl.dirty && showErrorMessage()) {
      <mat-error>{{ 'validations.required' | translate }}</mat-error>
    }

    <mat-error>
      @if (ngControl.dirty && showErrorMessage()) {
        @switch (true) {
          @case (ngControl?.control?.hasError('dateNotEarlierThan')) {
            @let dateNotEarlierThan = ngControl.control.getError('dateNotEarlierThan');

            {{
              'validations.dateNotEarlierThan'
                | translate
                  : {
                      date: dateNotEarlierThan.date | translate,
                      earlierThanDate: dateNotEarlierThan.comparisonDate | translate,
                    }
            }}
          }
          @case (ngControl?.control?.hasError('dateNotLaterThan')) {
            @let dateNotLaterThan = ngControl.control.getError('dateNotLaterThan');

            {{
              'validations.dateNotLaterThan'
                | translate
                  : {
                      date: dateNotLaterThan.date | translate,
                      laterThanDate: dateNotLaterThan.comparisonDate | translate,
                    }
            }}
          }
          @case (ngControl?.control?.hasError('matDatepickerMin')) {
            {{ 'validations.matDatepickerMin' | translate }}
          }
        }
      }
    </mat-error>
  </mat-form-field>
}
